import React, { useEffect, useState } from 'react';

import { useAppDispatch } from 'src/store';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  useEffect(() => {
    document.body.classList.add('nft-connect', 'parallax');
  }, [dispatch]);

  return (
    <>
      <div className="page-wrapper">
        <Outlet />
      </div>

      <div className="scroll-top">
        <a className="smoothscroll" href="#top">
          <i className="bi bi-arrow-up-square"></i>
        </a>
      </div>
    </>
  );
};

export default MainLayout;
